import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useDropzone } from 'react-dropzone'

import { AppStateType } from '../../../bll/store'
import Profile from './profile'
import openNotification from '../../_ui/notification'
import { editMyProfile, uploadAvatar } from '../../../bll/login/loginOperations'
import errorHandler from '../../../bll/errorHandler'

const ProfileContainer = (props: any) => {
    const [getVisibleEditProfle, setVisibleEditProfle] = React.useState(false) // Видимость окна редактирования профиля оператора

    const [valueLastName, setValueLastName] = React.useState('') // Фамилия в окне редактирования профиля
    const [valueFirstName, setValueFirstName] = React.useState('') // Имя в окне редактирования профиля
    const [valueSecondName, setValueSecondName] = React.useState('') // Отчество в окне редактирования профиля
    const [valuePosition, setValuePosition] = React.useState('') // Должность в окне редактирования профиля
    const [valuePhoneNumber, setValuePhoneNumber] = React.useState('') // Номер телефона в окне редактирования профиля

    // Загрузка файлов на сервер
    const onDrop = React.useCallback((acceptedFiles: any) => {
        acceptedFiles.forEach((file: any) => {
            props.uploadAvatar(file).then((result: any) => {
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Ошибка загрузки аватара...", props.msg.err_0012, "error", "bottomRight") }
                    case "ERR_FILE_NOT_FOUND": { return openNotification("Ошибка загрузки аватара...", props.msg.err_0013, "error", "bottomRight") }
                    case "ERR_FILE_EXTNAME": { return openNotification("Ошибка загрузки аватара...", props.msg.err_0014, "error", "bottomRight") }
                    case "ERR_FILE_SIZE": { return openNotification("Ошибка загрузки аватара...", props.msg.err_0015, "error", "bottomRight") }
                    
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    const { getRootProps, isDragAccept } = useDropzone({ onDrop }) // Свойства дропзоны

    // Открытие окна редактирование профиля оператора
    const openDialogEditProfile = () => {
        setValueLastName(props.myProfile.lastName)
        setValueFirstName(props.myProfile.firstName)
        setValueSecondName(props.myProfile.secondName)
        setValuePosition(props.myProfile.position)
        setValuePhoneNumber(props.myProfile.phoneNumber.substring(2, props.myProfile.phoneNumber.length))

        setVisibleEditProfle(true)
    }

    // Закрытие окна редактирование профиля оператора
    const closeDialogEditProfile = () => {
        setVisibleEditProfle(false)

        setValueLastName('')
        setValueFirstName('')
        setValueSecondName('')
        setValuePosition('')
        setValuePhoneNumber('')
    }

    // Применить изменения для профиля оператора
    const applyEditProfile = () => {
        let errorForm = false

        if (valueLastName.trim().length < 2) {
            errorForm = true
            openNotification("Фамилия оператора...", "Должно быть не меньше двух символов и не может быть пустым.", "warning", "bottomRight")
        }

        if (valueFirstName.trim().length < 2) {
            errorForm = true
            openNotification("Имя оператора...", "Должно быть не меньше двух символов и не может быть пустым.", "warning", "bottomRight")
        }

        if (valuePhoneNumber.trim().length > 0) {
            const regexPhoneNumber = new RegExp(`^[0-9]{10}$`)
            if (!regexPhoneNumber.test(valuePhoneNumber)) {
                errorForm = true
                openNotification("Номер телефона...", `Номер телефона может содержать только цифры и должен быть не меньше 10 символов (БЕЗ +7 и 8 в начале).`, "warning", "bottomRight")
            }
        }

        // Если ошибок не обнаружено
        if (!errorForm) {
            let phoneNumber = ''
            if (valuePhoneNumber) {
                phoneNumber = `+7${valuePhoneNumber}`
            }

            props.editMyProfile(valueLastName, valueFirstName, valueSecondName, valuePosition, phoneNumber).then((result: any) => {
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Профиль оператора...", props.msg.err_0016, "error", "bottomRight") }

                    default:  errorHandler(result?.code, props.msg); break
                }
            })
            closeDialogEditProfile()
        }
    }

    // Очистка формы редактирования профиля оператора
    const clearDialogEditProfile = (fieldType: string) => {
        if (fieldType === "lastName") { setValueLastName('') }
        if (fieldType === "firstName") { setValueFirstName('') }
        if (fieldType === "secondName") { setValueSecondName('') }
        if (fieldType === "position") { setValuePosition('') }
        if (fieldType === "phoneNumber") { setValuePhoneNumber('') }
    }


    // Свойства передаваемые в компоненту
    const propsToProfile = {
        getRootProps, isDragAccept, // Свойства дропзоны

        openDialogEditProfile, closeDialogEditProfile, clearDialogEditProfile, applyEditProfile,  // Открытие, Закрытие, Очистка, Применить редактирование профиля оператора
        getVisibleEditProfle, setVisibleEditProfle, // Видимость окна редактирования профиля оператора
        valueLastName, setValueLastName, // Фамилия в окне редактирования профиля
        valueFirstName, setValueFirstName, // Имя в окне редактирования профиля
        valueSecondName, setValueSecondName, // Отчество в окне редактирования профиля
        valuePosition, setValuePosition, // Должность в окне редактирования профиля
        valuePhoneNumber, setValuePhoneNumber, // Номер телефона в окне редактирования профиля
    }

    return (
        <Profile {...props} {...propsToProfile} />
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        myProfile: state.login.myProfile,
    }
}

export default compose(connect(mapState, { uploadAvatar, editMyProfile }))(ProfileContainer)